<ng-container>
  @if (!groupBy) {
    <ng-select [items]="optionList" [multiple]="true" [maxSelectedItems]="" [bindValue]="inputKey" [bindLabel]="labelKey" [(ngModel)]="value" [disabled]="isDisabled" [placeholder]="placeholder"
      [tabIndex]="tabIndex" [appendTo]="appendTo" [clearOnBackspace]="clearOnBackspace" (change)="changeEvent.emit($event)" (open)="onOpen()" (close)="onClose()">
    </ng-select>
  }

  @if (groupBy) {
    <ng-select [items]="optionList" [multiple]="true" [groupBy]="groupBy" [bindValue]="inputKey" [maxSelectedItems]="" [bindLabel]="labelKey" [disabled]="isDisabled" [(ngModel)]="value"
      [placeholder]="placeholder" [tabIndex]="tabIndex" (change)="changeEvent.emit($event)" [appendTo]="appendTo" [clearOnBackspace]="clearOnBackspace" (open)="onOpen()" (close)="onClose()">
      <ng-template ng-optgroup-tmp let-item="item">
        {{ item[groupBy] || 'Unnamed group' }}
      </ng-template>
    </ng-select>
  }
</ng-container>

@if (parentForm) {
  <fn-input-error [position]="'bottom'" [submitted]="parentForm.submitted" [control]="parentForm.form.controls[name]" [tabIndex]="tabIndex">
  </fn-input-error>
}